module.exports = __webpack_public_path__ + "img/symbol_2.ceca25b7.png";